import type { CheckAccount } from '../type';

export const GuestToMasterService = Symbol.for('GuestToMasterService');

export interface GuestToMasterService {
  checkAccount(email: string, isLogin: boolean): Promise<CheckAccount>;
}
